export type NotificationCount = {
  unseen: number
  unread: number
  total: number
}

export enum Context {
  PRODUCTS = 'CLUB',
  ACTIVITIES = 'SPARKLE'
}

export enum Role {
  CREATOR = 'CREATOR',
  CONSUMER = 'CONSUMER'
}

export type NotificationsParams = {
  language: string
  context: Context
  nextToken?: string
  size?: number
  role?: Role
}

export type CountParams = {
  context: Context
}

export type ReadAllParams = {
  markRead: boolean
  context: Context
}

export type ActivitieNotification = {
  title: string
  content: string
  time: string
  seen: boolean
  read: boolean
  metadata: {
    news: string
    traceId: string
    messageKey: string
    silent: boolean
    collection: string
    notificationType: string
    community: string
    titleKey: string
    url: string
    membershipSlug: string
    notificationHistoryId: string
    senderId: string
    post: string
    context: string
    communityName: string
    postTitle: string
    userFirstAndMiddleNames: string
    user: string
  }
}

export enum CLUB_NOTIFICATION_TYPE {
  COMMENT = 'COMMENT',
  LIKE = 'LIKE',
  DRIPPING = 'DRIPPING',
  REPLY = 'REPLY'
}

export type ProductNotification = {
  read: boolean
  seen: boolean
  time: string
  title: string
  metadata: {
    isMembershipModeration: boolean
    silent: boolean
    isPersona: boolean
    role: string
    productId: string
    slugMembership: string
    contentName: string
    key: string
    context: string
    destiny: string
    membershipName: string
    productName: string
    messageKey: string
    notificationType: string
    picture?: string
    senderId: string
    titleKey: string
    type: CLUB_NOTIFICATION_TYPE
    traceId: string
    url: string
    userName?: string
    userFirstAndMiddleNames?: string
  }
}

export type ActivitieNotificationList = {
  nextToken?: string
  notifications: ActivitieNotification[]
}

export type ProductNotificationList = {
  nextToken?: string
  notifications: ProductNotification[]
}

export type NotificationList = ActivitieNotificationList | ProductNotificationList
